import {AxiosResponse} from "axios";
import {ApiService} from "../api";
import {SharedCountDTO} from "../../types/DTOs/Dashboard/SharedCountDTO";
import {ShareListDTO} from "../../types/DTOs/ShareListDTO";
import {CvSectionDTO} from "../../types/DTOs/Dashboard/CvSectionDTO";
import {ShareListDashboardDTO} from "../../types/DTOs/Dashboard/ShareListDashboardDTO";

export class DashboardAPI extends ApiService {
    private constructor() {
        super();
    }

    async getCountViews(): Promise<SharedCountDTO> {
        const response: AxiosResponse<SharedCountDTO> = await this.api.get('/dashboard/viewcount');
        return response.data;
    }

    async getSharesList(): Promise<ShareListDashboardDTO[]> {
        const response: AxiosResponse<ShareListDashboardDTO[]> = await this.api.get('/dashboard/shares');
        return response.data;
    }

    async getSectionCounter(cvVersionId: string): Promise<CvSectionDTO[]> {
        const response: AxiosResponse<CvSectionDTO[]> = await this.api.get('/dashboard/section/' + cvVersionId);
        return response.data;
    }
}